//* Importações do vue (Padrão vuetify)
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

//*Importação do VueFire
import VueFire from 'vuefire'
Vue.use(VueFire)


//TODO: Lato font offline
//! import './assets/fonts/latoFont.css'

Vue.config.productionTip = false

// //* Inicializar o Vue
var vm = new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

global.vm = vm